import luxy from "luxy.js";

/*
 *
 * ----------------------------------------------- */
jQuery(window).on("load", function () {
  if ($("#luxy").length) {
    luxy.init();
  }
});

/**
 *
 *
 *
 ******************************************/
// var sceneSectionHistory = gsap.timeline();
//
// ScrollTrigger.create({
//   animation: sceneSectionHistory,
//   trigger: "#gsap-scroll-trigger",
//   start: "top top",
//   end: "70% 100%",
//   scrub: 5,
// });
//
// sceneSectionHistory.to(".img-1", { y: isMobile() ? -50 : -120 }, 0);
//
// /**
//  *
//  *
//  *
//  ******************************************/
// var sceneSectionHistory2 = gsap.timeline();
//
// ScrollTrigger.create({
//   animation: sceneSectionHistory2,
//   trigger: "#gsap-scroll-trigger-2",
//   start: "top top",
//   end: "70% 100%",
//   scrub: 4,
// });
//
// sceneSectionHistory2.to(".img-2", { y: isMobile() ? -50 : -120 }, 0);
//
